import { CartUpdatedEvent } from '@theme/events';

(function () {
  function initGallery(root) {
    var mainImg = root.querySelector('[data-cro-main-img]');
    if (!mainImg) return;

    root.querySelectorAll('[data-cro-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (!src) return;

        mainImg.src = src;
        if (btn.dataset.srcset) {
          mainImg.srcset = btn.dataset.srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
        if (btn.dataset.sizes) {
          mainImg.sizes = btn.dataset.sizes;
        } else {
          mainImg.removeAttribute('sizes');
        }

        root.querySelectorAll('[data-cro-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-current', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
      });
    });

    var zoomBtn = root.querySelector('[data-cro-zoom]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var zoomSrc = mainImg.currentSrc || mainImg.src;
        if (zoomSrc) window.open(zoomSrc, '_blank', 'noopener');
      });
    }
  }

  function initShowMore(root) {
    var desc = root.querySelector('[data-cro-desc]');
    var btn = root.querySelector('[data-cro-show-more]');
    if (!desc || !btn) return;
    if (desc.scrollHeight <= 140) {
      btn.hidden = true;
      return;
    }
    btn.addEventListener('click', function () {
      var collapsed = desc.classList.toggle('is-collapsed');
      btn.textContent = collapsed ? 'Afficher plus' : 'Afficher moins';
    });
  }

  function initReviews(root) {
    var slides = root.querySelectorAll('[data-cro-review]');
    if (slides.length < 2) return;
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (el, idx) {
        el.hidden = idx !== index;
      });
    }

    var prev = root.querySelector('[data-cro-review-prev]');
    var next = root.querySelector('[data-cro-review-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    show(0);
  }

  function initFaq(root) {
    root.querySelectorAll('[data-cro-faq-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-cro-faq-item]');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        root.querySelectorAll('[data-cro-faq-item]').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('[data-cro-faq-trigger]').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAddToCart() {
    document.querySelectorAll('form[data-cro-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var btn = form.querySelector('[type="submit"]');
        var variantInput = form.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) return;

        var cart = window.experaiseCart;
        if (!cart) {
          // Panier EXPERAISE pas encore chargé : envoi natif (page panier), le produit est ajouté dans tous les cas.
          form.submit();
          return;
        }

        if (btn) btn.classList.add('is-loading');

        cart.addVariant(variantInput.value, 1, 'cro-product-form')
          .catch(function (error) {
            console.error(error);
            document.dispatchEvent(
              new CustomEvent('toast:open', {
                detail: { type: 'error', message: error.message || String(error) },
              })
            );
          })
          .finally(function () {
            if (btn) btn.classList.remove('is-loading');
          });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-cro-sticky]');
    var hero = document.querySelector('.cro-hero');
    if (!bar || !hero) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    observer.observe(hero);
  }

  function boot() {
    initAddToCart();
    document.querySelectorAll('[data-cro-studio]').forEach(function (root) {
      initGallery(root);
      initShowMore(root);
      initReviews(root);
      initFaq(root);
    });
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
